import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-lists" }
const _hoisted_2 = { class: "app-lists__add" }
const _hoisted_3 = { class: "app-lists__add-text" }
const _hoisted_4 = { class: "app-lists__items" }
const _hoisted_5 = { class: "app-lists__items-item-name" }

import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppListSelectDropdown from "./AppListSelectDropdown.vue";
import { AnalyticsApi } from "@/ api/AnalyticsApi";
import type { AnalyticsListItem } from "@/store/clients";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLists',
  props: {
    modelValue: {},
    segment: {},
    elementId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const $dropdown = ref<typeof AppResizableDropdown | null>(null);

const close = () => {
	$dropdown.value?.close();
};

const refreshLists = async () => {
	try {
		const res = await AnalyticsApi.getListOfElement(props.elementId, props.segment);
		emit("update:modelValue", res?.Lists ?? []);
	} catch (e) {
		console.error(e);
	}
};

const onDelete = async (list: AnalyticsListItem) => {
	try {
		await AnalyticsApi.removeElementIntoList(list.Id, props.segment, props.elementId);
		emit(
			"update:modelValue",
			props.modelValue.filter((l) => l.Id !== list.Id),
		);
	} catch (e) {
		console.error(e);
	}
};

__expose({ close });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppResizableDropdown, {
        ref_key: "$dropdown",
        ref: $dropdown,
        position: "left",
        resizable: false,
        "initial-width": 320,
        "initial-height": 436,
        "close-by-click-outside": false,
        "content-z-index": 10003,
        "mobile-title": _ctx.$t('file_info_lists'),
        name: "$appLists"
      }, {
        activator: _withCtx(() => [
          _createVNode(AppTooltip, {
            text: _ctx.$t('add_to_list')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "app-lists__add-btn",
                name: "plus",
                width: "14px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer"
              })
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        default: _withCtx(() => [
          _createVNode(AppListSelectDropdown, {
            segment: _ctx.segment,
            "element-id": _ctx.elementId,
            "added-lists": _ctx.modelValue,
            "show-close-icon": "",
            onClose: close,
            onAddList: refreshLists
          }, null, 8, ["segment", "element-id", "added-lists"])
        ]),
        _: 1
      }, 8, ["mobile-title"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("file_info_lists")) + ":", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (list) => {
        return (_openBlock(), _createElementBlock("div", {
          key: list.Id,
          class: "app-lists__items-item"
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(list.Name), 1),
          _createVNode(AppIcon, {
            class: "app-lists__items-item-delete",
            name: "close",
            width: "12px",
            color: "#D2D2D2",
            "hover-color": "#499259",
            cursor: "pointer",
            onClick: ($event: any) => (onDelete(list))
          }, null, 8, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}
}

})